// Using jquery ui to create tabs functionality.
// The tabs need to have a wrapper with class .tabs and a unique ID

$(document).ready(function () {
    var $tabs = $('.tabs');

    $tabs.each(function(i){
        var tab = $($tabs[i]);
        var tabID = "#"+ tab.attr('id');

        $(tabID).tabs({
            create: function( event, ui ) {
            }
        });
    })
  });